import React from 'react';

import Layout from '../components/Layout';
import SEO from '../components/SEO';

import CurrentCampaign from '../components/CurrentCampaign';
import About from '../components/About';

export default function render() {
  return (
    <Layout solidHeader={true}>
      <SEO title="Erro 404" description="Página não encontrada." />
      <main className="container">
        <div className="wrap">
          <h1 className="title">Erro 404</h1>
          <p>Página não encontrada.</p>
        </div>
      </main>

      <CurrentCampaign />
      <About />
    </Layout>
  );
}
